"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ErrorCircleOutline_1 = __importDefault(require("@kyruus/react-ikons/ErrorCircleOutline"));
const contexts_1 = require("../../lib/contexts");
const styles_1 = require("./styles");
const DebugErrorFallback = ({ error }) => {
    return (react_1.default.createElement(styles_1.ErrorContainer, { "data-testid": "debug-error-fallback" },
        react_1.default.createElement(styles_1.ErrorIconContainer, null,
            react_1.default.createElement(ErrorCircleOutline_1.default, { color: 'red', size: "24px" })),
        react_1.default.createElement(styles_1.ErrorMessageContainer, null, error.toString())));
};
const ErrorFallback = ({ error }) => {
    const isDebugErrorBoundary = (0, react_1.useContext)(contexts_1.DebugErrorBoundaryContext);
    // if in debug mode, render visible error
    if (isDebugErrorBoundary) {
        return react_1.default.createElement(DebugErrorFallback, { error: error });
    }
    // otherwise render nothing to make the UI as functional as possible
    return react_1.default.createElement("div", { "data-testid": "error-fallback" });
};
exports.default = ErrorFallback;
//# sourceMappingURL=error-fallback.js.map